import React, { useEffect } from 'react';
import { Hero } from '../components/Hero';
import { ProductBreakdown } from '../components/ProductBreakdown';
import { Benefits } from '../components/Benefits';
import { Testimonials } from '../components/Testimonials';
import { CallToAction } from '../components/CallToAction';
import { CheckoutSection } from '../components/CheckoutSection';
import { PurchasePopup } from '../components/PurchasePopup';
export function LandingPage() {
  useEffect(() => {
    // Smooth scroll with offset for fixed header
    const handleAnchorClick = (e: MouseEvent) => {
      const target = e.target as HTMLAnchorElement;
      if (target.tagName === 'A' && target.hash) {
        const href = target.getAttribute('href');
        if (href?.startsWith('#')) {
          e.preventDefault();
          const targetId = href.substring(1);
          const targetElement = document.getElementById(targetId);
          if (targetElement) {
            const headerOffset = 64; // Reduced header height
            const elementPosition = targetElement.getBoundingClientRect().top;
            const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
            window.scrollTo({
              top: offsetPosition,
              behavior: 'smooth'
            });
          }
        }
      }
    };
    document.addEventListener('click', handleAnchorClick);
    return () => document.removeEventListener('click', handleAnchorClick);
  }, []);
  return <div className="min-h-screen bg-white font-sans text-gray-900" data-id="element-303">
      <header className="fixed top-0 left-0 right-0 z-50 bg-white/90 backdrop-blur-md border-b border-gray-200 shadow-sm" data-id="element-304">
        <div className="container mx-auto px-4 h-16 flex items-center justify-between" data-id="element-305">
          <div className="font-serif font-black text-lg text-red-800 flex items-center gap-2" data-id="element-306">
            <span data-id="element-307">🎵</span> MegaPackMúsica
          </div>
          <nav className="hidden md:flex items-center gap-6 text-sm font-semibold text-gray-700" data-id="element-308">
            <a href="#que-incluye" className="hover:text-red-700 transition-colors" data-id="element-309">
              Qué Incluye
            </a>
            <a href="#beneficios" className="hover:text-red-700 transition-colors" data-id="element-310">
              Beneficios
            </a>
            <a href="#testimonios" className="hover:text-red-700 transition-colors" data-id="element-311">
              Testimonios
            </a>
            <a href="#comprar" className="bg-red-700 text-white px-5 py-2 rounded-full hover:bg-red-800 transition-all text-xs font-black uppercase tracking-wide shadow-lg hover:shadow-xl transform hover:-translate-y-0.5" data-id="element-312">
              Comprar
            </a>
          </nav>
        </div>
      </header>

      <main data-id="element-313">
        <Hero data-id="element-314" />
        <ProductBreakdown data-id="element-315" />
        <div id="beneficios" data-id="element-316">
          <Benefits data-id="element-317" />
        </div>
        <CheckoutSection data-id="element-318" />
        <div id="testimonios" data-id="element-319">
          <Testimonials data-id="element-320" />
        </div>
        <CallToAction data-id="element-321" />
      </main>

      <footer className="bg-gray-900 text-gray-400 py-16 border-t border-gray-800" data-id="element-322">
        <div className="container mx-auto px-4 flex flex-col md:flex-row justify-between items-center gap-8" data-id="element-323">
          <div className="text-center md:text-left" data-id="element-324">
            <h3 className="text-white font-serif font-black text-2xl mb-3" data-id="element-325">
              MegaPack Música Lista
            </h3>
            <p className="text-base" data-id="element-326">
              Recursos educativos para docentes apasionados.
            </p>
          </div>
          <div className="text-base text-center md:text-right" data-id="element-327">
            <p data-id="element-328">
              &copy; {new Date().getFullYear()} Todos los derechos reservados.
            </p>
          </div>
        </div>
      </footer>
      <PurchasePopup data-id="element-329" />
    </div>;
}